import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface FormFieldConfig {
  external_name: string;
  type: string; // Tipo di campo (es. 'text', 'select', 'date')
  default?: any; // Valore di default
  editable?: boolean; // disabled
  required?: boolean;
  enum_values?: string[]; // Opzioni (usate per campi di tipo 'select')
}

@Injectable({
  providedIn: 'root'
})
export class DynamicFormService {
  private formConfigs: {
    [id: string]: BehaviorSubject<{ fields: FormFieldConfig[]; attributes: FormFieldConfig[] }>;
  } = {};

  setFormConfig(id: string, fields: FormFieldConfig[], attributes?: FormFieldConfig[]) {
    if (!this.formConfigs[id]) {
      this.formConfigs[id] = new BehaviorSubject<{ fields: FormFieldConfig[]; attributes: FormFieldConfig[] }>({
        fields,
        attributes: attributes || []
      });
    } else {
      this.formConfigs[id].next({ fields, attributes: attributes || [] });
    }
  }

  getFormConfig(id: string): Observable<{ fields: FormFieldConfig[]; attributes: FormFieldConfig[] }> {
    if (!this.formConfigs[id]) {
      this.formConfigs[id] = new BehaviorSubject<{
        fields: FormFieldConfig[];
        attributes: FormFieldConfig[];
      }>({ fields: [], attributes: [] });
    }
    return this.formConfigs[id].asObservable();
  }
}
